import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import Header from "../common/header/Header";
import SubHeader from "../common/header/subHeader/SubHeader";
import HeaderBar from "../common/header/headerBar/HeaderBar";
import Content from "../common/content/Content";
import Footer from "../common/footer/Footer";
import LoadingScreen from "../common/loadingScreen/LoadingScreen";

class App extends React.Component {
  render() {
    const { loading } = this.props.common;

    const isLoading = loading.length > 0;

    return (
      <div>
        <main>
          <Header />
          <SubHeader />
          <HeaderBar loading={isLoading} />
          <LoadingScreen loading={isLoading} />
          <Content loading={isLoading} />
          <Footer />
        </main>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    common: state.common
  };
};

export default withRouter(connect(mapStateToProps)(App));



// WEBPACK FOOTER //
// ./src/routes/app/index.js